<template>
  <div class="fileinput text-center">
    <div class="col-lg-12">
      <div class="row" style="padding-left: 15px">
        <label for="file-upload" type="primary" class="btn"> Upload </label>
        <input
          accept="application/pdf"
          id="file-upload"
          type="file"
          name="..."
          class="valid"
          :multiple="false"
          aria-invalid="false"
          style="display: none"
          v-on:change="onFileChange"
        />
      </div>

      <div class="row">
        <div class="col-lg-7">
          <p style="color: #A5A5A5" v-if="selectedFileName" id="file-name">
            {{ selectedFileName }}
          </p>
        </div>
        <div class="col-lg">
          <p
            v-if="selectedFileName"
            style="padding-left: 30px; font-size: 12px; color: lightgray"
            @click="removeFile"
          >
            {{ removeText }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "image-upload",
  props: {
    type: {
      type: String,
      default: "",
      description: 'Image upload type (""|avatar)',
    },
    src: {
      type: String,
      default: "",
      description: "Initial image to display",
    },
    selectText: {
      type: String,
      default: "Upload",
    },
    changeText: {
      type: String,
      default: "Change",
    },
    removeText: {
      type: String,
      default: "Remove",
    },
  },
  data() {
    let avatarPlaceholder = "img/placeholder.jpg";
    let imgPlaceholder = "img/image_placeholder.jpg";
    return {
      selectedFileName: "",
      placeholder: this.type === "avatar" ? avatarPlaceholder : imgPlaceholder,
      imagePreview: null,
    };
  },
  computed: {
    fileExists() {
      return this.imagePreview !== null;
    },
    image() {
      return this.imagePreview || this.src || this.placeholder;
    },
  },
  methods: {
    onFileChange(event) {
      const input = event.target;
      if (input.files.length > 0) {
        this.selectedFileName = input.files[0].name; // Update selectedFileName with the file name
      } else {
        this.selectedFileName = ""; // Clear selectedFileName if no file is selected
      }
    },
    handlePreview(event) {
      let file = event.target.files[0];
      this.imagePreview = URL.createObjectURL(file);
      this.$emit("change", file);
    },
    removeFile() {
      this.selectedFileName = null;
      this.$emit("change", null);
    },
  },
};
</script>
<style>
input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
  display: none;
}
</style>
